export const hyundaiMallNos = [79828, 80046];

export const kiaMallNos = [79826, 80047];
